import React, { memo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import DropDown from 'src/components/common/field/DropDown';
import InputCustom from 'src/components/common/field/InputCustom';
import { ItemTypeTable } from 'src/components/templates/quotation/DialogForm';

type RecordProps = {
  items: ItemTypeTable[];
  loading?: boolean;
  surgeries: any[];
  onClickAddRow?: () => void;
  onClickDelete?: (index: number) => void;
  onChangeItem: (index: number, fieldName: string, value: string | number | null) => void;
  error?: any;
};

const Record: React.FC<RecordProps> = (props) => {
  const handleChangeDropDown = (index: number, fieldName: string) => (value: string | number) => {
    props.onChangeItem(index, fieldName, value);
  };

  const handleChangeInput = (index: number, fieldName: string) => (value: string | number | null) => {
    props.onChangeItem(index, fieldName, value);
  };

  const handleDeleteRow = (index: number) => () => {
    props.onClickDelete?.(index);
  };

  // const checkError = (index: number, fieldName: string) => {
  //   return props.error && props.error.index === index && props.error.fieldName === fieldName;
  // };

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '14px' },
      }}
    >
      <Table
        stickyHeader
        sx={{
          width: '100%',
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '0px',
            fontWeight: 700,
            fontSize: '14px',
            height: '36px',
            p: '0px 4px',
          }
        }}
        aria-label='simple table'>
        <TableHead >
          <TableRow >
            <TableCell align={'left'} sx={{ width: '40%', bgcolor: 'primary.light' }}>施術名</TableCell>
            <TableCell align={'left'} sx={{ width: '40%', bgcolor: 'primary.light' }}></TableCell>
            <TableCell align={'left'} sx={{ width: '15%', bgcolor: 'primary.light' }}>数量</TableCell>
            <TableCell align={'left'} sx={{ width: '5%', bgcolor: 'primary.light' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.loading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Stack spacing={1}>
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                </Stack>
              </TableCell>
            </TableRow>
          ) : (
            props.items.map((item: ItemTypeTable, index: number) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '& .MuiTableCell-root.MuiTableCell-body': {
                    p: '4px',
                    borderBottom: '0px',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '14.4px'
                  },
                  height: '48px',
                }}
              >
                <TableCell component='td' scope='row' sx={{ verticalAlign: 'top' }}>
                  <Box sx={{ width: '100%' }}>
                    <DropDown
                      idSelect='surgeryid'
                      selected={item.surgeryid}
                      items={props.surgeries}
                      onChange={handleChangeDropDown(index, 'surgeryid')}
                      sxInput={{
                        '.MuiSvgIcon-root': { fontSize: '24px' },
                        maxWidth: '372px'
                      }}
                      sxMenuProps={{
                        maxWidth: '372px'
                      }}
                    />
                  </Box>
                </TableCell>

                <TableCell component='td' scope='row' sx={{ verticalAlign: 'top' }}>
                  <InputCustom
                    name='note'
                    type='text'
                    value={item.note}
                    onChange={handleChangeInput(index, 'note')}
                    sx={{ width: '100%' }}
                  />
                </TableCell>

                <TableCell component='td' scope='row' sx={{ verticalAlign: 'top' }}>
                  <InputCustom
                    name='qty'
                    type='number'
                    min={0}
                    max={99}
                    value={item.qty}
                    onChange={handleChangeInput(index, 'qty')}
                    sx={{ width: '100%' }}
                  />
                </TableCell>


                <TableCell component='td' scope='row' sx={{ verticalAlign: 'top' }}>
                  {props.items.length > 1 && (
                    <Box sx={{ height: '48px', display: 'flex', alignContent: 'center' }}>
                      <IconButton title='Delete row' sx={{ p: 0 }} onClick={handleDeleteRow(index)}>
                        <img src='/images/icons/ic-delete-bin-red.svg' style={{ width: '20px', height: '20px' }} alt='icon' />
                      </IconButton>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>

      </Table>
      <IconButton title='Add row' sx={{ p: 0 }} onClick={props.onClickAddRow}>
        <img src='/images/ic-plus-blue.svg' style={{ width: '20px', height: '20px' }} alt='icon' />
        <Typography
          component='label'
          sx={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '14.4px',
            color: '#23B7E5'
          }}
        >
          追加する
        </Typography>
      </IconButton>
    </TableContainer>
  );
};

export default memo(Record);
